module.exports = __webpack_public_path__ + "img/warning-error.1bba7ad4.svg";